var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"finalize-button button is-primary",attrs:{"id":"finalizeRevisionButton"},on:{"click":_vm.openCloseModal}},[_vm._v(" Finalizar ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }